<template>
    <v-card>
        <v-card-title class="title">Підтвердження публікації результатів</v-card-title>
        <v-card-text>
            Ви впевнені, що хочете опублікувати ВСІ результати за ВИБРАНИЙ день?
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                    color="primary"
                    text
                    @click.native="$emit('shouldCloseDeleteConfirm')"
                    :disabled="loadingDelete"
            >Відміна
            </v-btn>
            <v-btn
                    color="red darken-3"
                    dark
                    @click.native="removeItem"
                    :loading="loadingDelete"
                    :disabled="loadingDelete"
            >Опублікувати
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
    import HttpService from "../../../HttpService";

    export default {
        data: () => {
            return {
                loadingDelete: false,
            };
        },
        props: {
            deleteId: Number,
        },
        methods: {
            removeItem() {
                this.loadingDelete = true;

                HttpService.getInstance()
                    .post(`FinalExamAdminManage/PublishResults?dateStr=${this.$route.params.date}`)
                    .then(resp => {
                        this.loadingDelete = false;

                        this.$emit("removed");
                    });
            }
        }
    }
</script>